import { useMemo, useState } from 'react';

import { PRODUCT_IMAGE_PATH } from '@shared/config/paths/paths';
import { useAppSelector } from '@shared/hooks/redux';
import { ProductPropertyValueType } from '@shared/types/product';
import { getViewPort } from '@shared/ui/ScreenSizeTracking';

type UseLightBoxModalProps = {
  values: ProductPropertyValueType[];
  mobileOn?: boolean;
};

export const useLightBoxModal = ({ values, mobileOn }: UseLightBoxModalProps) => {
  const viewPort = useAppSelector(getViewPort);
  const [openLightBoxModal, setOpenLightBoxModal] = useState(false);
  const [currentImgUrl, setCurrentImgUrl] = useState('');

  const isMobile = viewPort === 'mobile';

  const imageUrls = useMemo(() => values?.map((image) => `${PRODUCT_IMAGE_PATH}/${image.value}/800.webp`), [values]);

  const handleCloseLightBox = () => {
    setOpenLightBoxModal(false);
  };

  const handleChangeCurrentImageUrl = (url: string) => () => {
    if (isMobile && !mobileOn) return;
    setCurrentImgUrl(url);
    setOpenLightBoxModal(true);
  };

  return {
    openLightBoxModal,
    currentImgUrl,
    imageUrls,
    handleChangeCurrentImageUrl,
    handleCloseLightBox
  };
};
